import Poll from './Poll';
import PollOption from './PollOption';
import PollVote from './PollVote';

export const models = {
  Poll,
  PollOption,
  PollVote,
};
